const MODULE_NAME = "fichaAlumnoModule"

import fichaAlumnoModuleName from "./ficha-alumno.module"
import "./style"

// -> Ficha
import "./components/ficha-alumno/ficha-alumno.component"
import "./components/antecedentes/antecedentes.component"
import "./components/tab-notas/tab-notas.component"
import "./components/tab-datos/tab-datos.component"
import "./components/alertas/alertas.component"
import "./components/atenciones/atenciones.component"
import "./components/atenciones/formularios/controllers"
import "./components/alertas/formularios/controllers.js"
// import "./resumen-alumno/resumen-alumno.component.js";
// import "./historial/historial.component.js";

export default fichaAlumnoModuleName
